import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 540.000000 553.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M0 5505 l0 -25 2700 0 2700 0 0 25 0 25 -2700 0 -2700 0 0 -25z"/>
<path d="M2244 3746 c-107 -26 -207 -110 -246 -206 -21 -51 -23 -70 -23 -265
0 -174 3 -216 17 -245 32 -68 80 -122 144 -162 38 -24 63 -46 60 -53 -2 -7 -8
-61 -12 -120 l-7 -108 24 5 c13 2 101 54 194 114 l170 109 305 5 c303 5 305 5
360 31 80 37 125 81 162 157 l33 67 0 210 c0 209 0 210 -27 266 -54 109 -120
164 -235 193 -51 13 -127 16 -464 15 -285 0 -419 -4 -455 -13z m317 -369 c61
-46 49 -148 -21 -177 -35 -15 -67 -8 -103 21 -23 17 -27 28 -27 70 0 41 5 54
26 74 30 28 96 34 125 12z m400 0 c61 -46 49 -148 -21 -177 -64 -26 -130 22
-130 95 0 59 36 95 94 95 22 0 48 -6 57 -13z"/>
<path d="M2203 2350 c-76 -11 -124 -81 -103 -146 14 -41 48 -67 119 -88 65
-19 81 -31 81 -62 0 -55 -86 -68 -145 -23 l-26 21 -25 -23 c-13 -12 -24 -26
-24 -30 0 -4 25 -20 55 -34 47 -23 65 -27 117 -23 53 4 65 9 89 36 24 27 29
41 29 83 0 64 -23 88 -113 118 -82 28 -106 60 -71 95 20 21 76 20 116 0 30
-16 32 -15 49 7 21 28 19 32 -23 52 -46 21 -77 25 -125 17z"/>
<path d="M3957 2347 c-168 -55 -200 -276 -53 -374 41 -28 57 -33 110 -33 107
1 179 50 211 144 53 162 -104 317 -268 263z m115 -66 c37 -14 77 -60 84 -97
20 -108 -63 -198 -165 -178 -41 8 -88 55 -100 99 -11 41 3 111 27 139 35 39
105 56 154 37z"/>
<path d="M687 2318 c-8 -18 -29 -73 -47 -123 -18 -49 -45 -122 -61 -162 -16
-39 -29 -76 -29 -82 0 -6 17 -11 39 -11 37 0 39 2 51 45 l13 45 87 0 88 0 14
-42 c13 -39 18 -43 51 -46 27 -2 37 1 37 12 0 14 -74 215 -124 336 -22 53 -25
55 -64 58 -38 3 -42 1 -55 -30z m73 -100 c8 -24 17 -47 20 -53 4 -5 10 -22 14
-37 l6 -28 -61 0 c-54 0 -60 2 -54 18 4 9 16 45 28 80 11 34 24 62 27 62 4 0
13 -19 20 -42z"/>
<path d="M1000 2145 l0 -206 123 3 122 3 3 33 3 32 -85 0 -86 0 -2 168 -3 167
-37 3 -38 3 0 -206z"/>
<path d="M1507 2343 c-4 -3 -7 -96 -7 -205 l0 -198 40 0 40 0 0 205 0 205 -33
0 c-19 0 -37 -3 -40 -7z"/>
<path d="M1672 2148 l3 -203 38 -3 37 -3 0 85 0 86 90 0 c102 0 103 -1 99 -90
-3 -78 -2 -80 36 -80 l35 0 0 205 0 205 -34 0 c-42 0 -49 -16 -44 -103 l3 -62
-92 -3 -93 -3 0 86 0 85 -40 0 -40 0 2 -202z"/>
<path d="M2560 2338 c0 -8 -20 -63 -44 -124 -25 -60 -59 -146 -75 -192 l-31
-83 42 3 c39 3 42 5 56 46 l14 42 88 0 87 0 13 -45 c12 -43 14 -45 51 -45 25
0 39 5 39 13 0 11 -70 199 -90 242 -5 11 -20 49 -33 85 l-24 65 -46 3 c-35 2
-47 -1 -47 -10z m84 -162 c15 -38 24 -71 21 -74 -5 -6 -107 -3 -113 2 -1 2 10
37 25 79 15 42 31 73 35 69 3 -4 18 -38 32 -76z"/>
<path d="M2860 2145 l0 -205 40 0 39 0 3 137 3 137 50 -74 c28 -41 67 -97 87
-125 21 -27 38 -56 38 -62 0 -9 16 -13 45 -13 l45 0 0 205 0 205 -34 0 c-43 0
-48 -18 -45 -157 2 -56 0 -105 -3 -108 -2 -3 -46 56 -97 130 -92 135 -92 135
-132 135 l-39 0 0 -205z"/>
<path d="M3450 2145 l0 -206 38 3 37 3 2 65 c2 46 8 69 21 82 17 17 20 15 77
-67 59 -83 61 -84 103 -85 23 0 42 4 42 9 0 5 -34 54 -75 109 -41 55 -75 104
-75 108 0 3 32 44 70 90 39 45 70 85 70 88 0 3 -18 6 -39 6 -37 0 -43 -5 -112
-87 l-74 -88 -5 85 -5 85 -37 3 -38 3 0 -206z"/>
<path d="M4320 2145 l0 -205 40 0 40 0 0 68 c0 55 4 72 19 86 21 19 25 14 120
-121 19 -28 29 -33 62 -33 21 0 39 4 39 9 0 5 -26 45 -58 88 -32 43 -67 91
-76 105 l-18 27 71 85 c39 47 71 87 71 90 0 3 -17 6 -38 6 -35 0 -43 -6 -115
-90 l-77 -91 0 91 0 90 -40 0 -40 0 0 -205z"/>
<path d="M4712 2148 l3 -203 38 -3 37 -3 0 205 0 206 -40 0 -40 0 2 -202z"/>
<path d="M1260 2125 l0 -35 81 0 80 0 -3 33 -3 32 -77 3 -78 3 0 -36z"/>
<path d="M2365 1771 c-51 -23 -75 -65 -75 -129 0 -40 6 -57 26 -81 44 -53 144
-64 196 -21 20 16 21 19 6 34 -19 18 -35 21 -40 6 -2 -6 -19 -13 -39 -16 -29
-5 -41 -1 -65 19 -40 35 -41 98 -1 133 32 27 60 30 99 10 25 -13 30 -13 44 1
15 15 14 18 -7 34 -21 16 -65 29 -93 29 -6 0 -29 -9 -51 -19z"/>
<path d="M2650 1772 c-158 -79 -62 -302 109 -251 113 34 125 201 18 250 -52
23 -82 24 -127 1z m115 -56 c13 -13 27 -35 30 -49 8 -30 -17 -82 -46 -98 -29
-15 -85 -3 -104 24 -17 25 -20 79 -4 108 22 42 89 50 124 15z"/>
<path d="M3853 1771 c-49 -23 -76 -67 -77 -128 -2 -79 75 -141 159 -129 24 4
53 15 64 24 18 15 19 19 6 37 -15 18 -16 18 -44 2 -42 -25 -68 -21 -103 13
-27 28 -30 35 -24 72 11 66 63 93 123 64 33 -16 36 -16 49 1 16 22 4 35 -45
52 -46 15 -59 14 -108 -8z"/>
<path d="M1067 1773 c-10 -9 -8 -235 1 -250 12 -19 140 -11 178 11 58 35 82
115 51 176 -24 48 -73 70 -152 70 -39 0 -75 -3 -78 -7z m165 -60 c12 -11 18
-31 18 -60 0 -60 -34 -96 -88 -91 l-37 3 -3 74 c-4 100 -1 105 50 97 24 -4 50
-14 60 -23z"/>
<path d="M1435 1744 c-8 -20 -15 -38 -15 -41 0 -2 -11 -28 -24 -56 -13 -29
-31 -71 -40 -94 l-16 -43 29 0 c22 0 31 7 41 30 12 29 15 30 71 30 54 0 60 -2
69 -25 7 -18 17 -25 35 -25 14 0 25 3 25 7 0 4 -23 63 -51 130 -49 116 -53
123 -80 123 -24 0 -31 -7 -44 -36z m67 -79 l17 -45 -39 0 -39 0 16 45 c8 25
18 45 22 45 4 0 14 -20 23 -45z"/>
<path d="M1634 1769 c-10 -16 7 -27 46 -31 l35 -3 5 -110 c5 -104 6 -110 27
-113 22 -3 22 -1 25 110 l3 113 38 3 c29 3 37 7 37 23 0 18 -8 19 -104 19 -65
0 -107 -4 -112 -11z"/>
<path d="M1970 1753 c-28 -75 -84 -209 -91 -219 -12 -15 -1 -24 28 -24 18 0
27 8 34 30 11 29 13 30 73 30 58 0 62 -2 72 -28 8 -20 18 -28 38 -30 32 -2 34
-10 -32 148 -46 111 -49 115 -80 118 -27 3 -34 -1 -42 -25z m74 -110 c7 -21 4
-23 -28 -23 -41 0 -42 3 -20 56 l16 38 13 -24 c7 -14 16 -35 19 -47z"/>
<path d="M2912 1648 c3 -128 4 -131 26 -133 21 -2 22 1 22 82 0 46 3 83 8 83
4 0 33 -36 65 -79 59 -80 100 -107 119 -79 5 7 7 40 4 72 -4 32 -6 88 -6 122
0 62 -1 64 -25 64 -25 0 -25 -1 -25 -80 0 -44 -4 -80 -8 -80 -5 0 -34 36 -66
80 -49 69 -61 80 -87 80 l-30 0 3 -132z"/>
<path d="M3222 1648 l3 -133 25 0 c24 0 25 2 30 84 l5 85 58 -81 c42 -58 66
-82 85 -86 15 -3 30 -3 34 0 5 2 8 62 8 134 l0 129 -30 0 -29 0 -3 -87 -3 -86
-60 86 c-54 78 -63 86 -93 87 l-33 0 3 -132z"/>
<path d="M3536 1772 c-6 -10 -6 -220 0 -244 4 -14 18 -16 97 -15 87 2 92 3 95
25 3 21 0 22 -67 22 l-71 0 0 35 0 35 60 0 c53 0 60 2 60 20 0 16 -8 19 -57
22 -57 3 -58 3 -61 36 l-3 32 71 0 c63 0 71 2 68 18 -3 14 -17 17 -95 20 -50
1 -94 -1 -97 -6z"/>
<path d="M4050 1760 c0 -17 7 -20 40 -20 l40 0 0 -109 c0 -61 4 -112 8 -115 5
-3 18 -3 30 1 20 5 22 12 24 112 l3 106 38 3 c29 3 37 7 37 23 0 18 -8 19
-110 19 -103 0 -110 -1 -110 -20z"/>
<path d="M1123 1290 c-25 -10 -53 -58 -53 -90 0 -60 61 -108 122 -96 45 9 58
24 58 67 0 39 0 39 -40 39 -29 0 -40 -4 -40 -15 0 -9 9 -15 25 -15 20 0 25 -5
25 -25 0 -22 -4 -25 -40 -25 -69 0 -104 68 -62 119 19 24 40 28 90 17 36 -8
44 7 13 24 -23 12 -68 12 -98 0z"/>
<path d="M1330 1200 l0 -101 63 3 c71 3 80 21 13 26 -34 2 -46 8 -51 22 -10
31 2 40 51 40 60 0 54 23 -7 30 -36 4 -45 9 -47 28 -3 22 8 26 81 25 9 0 17 6
17 14 0 9 -17 13 -60 13 l-60 0 0 -100z"/>
<path d="M1530 1199 c0 -76 3 -100 13 -97 7 3 14 31 17 72 l5 68 28 -35 c15
-19 38 -50 50 -69 21 -30 47 -44 47 -25 0 4 0 48 0 97 0 53 -4 90 -10 90 -6 0
-10 -28 -10 -65 0 -36 -4 -65 -8 -65 -5 0 -30 29 -57 65 -67 91 -75 88 -75
-36z"/>
<path d="M1775 1288 c-3 -11 -1 -100 4 -170 1 -15 11 -18 61 -18 46 0 60 3 60
14 0 11 -14 16 -47 18 -44 3 -48 5 -48 28 0 22 5 25 43 28 28 2 42 8 42 18 0
10 -12 14 -44 14 -43 0 -45 1 -43 28 2 25 6 27 47 27 25 1 45 6 48 13 2 8 -14
12 -57 12 -41 0 -63 -4 -66 -12z"/>
<path d="M1980 1199 c0 -76 3 -100 13 -96 6 2 12 19 12 38 0 27 5 35 23 37 16
3 26 -5 38 -32 16 -32 41 -53 51 -42 2 2 -4 19 -13 39 -16 33 -16 37 0 52 20
21 21 54 0 83 -12 18 -25 22 -70 22 l-54 0 0 -101z m110 55 c19 -21 -7 -45
-51 -47 -32 -2 -34 0 -36 31 -1 31 0 32 37 32 22 0 43 -6 50 -16z"/>
<path d="M2243 1268 c-6 -18 -22 -63 -37 -100 -21 -56 -23 -68 -11 -68 9 0 20
11 25 25 8 21 16 25 53 25 37 0 46 -4 55 -25 12 -26 32 -34 32 -12 -1 6 -16
50 -34 97 -24 63 -38 86 -53 88 -14 2 -22 -6 -30 -30z m54 -60 c14 -31 9 -38
-29 -38 -32 0 -34 5 -12 49 17 34 23 33 41 -11z"/>
<path d="M2432 1203 l3 -98 63 -3 c51 -2 62 0 62 13 0 11 -12 15 -50 15 l-50
0 0 85 c0 70 -3 85 -15 85 -13 0 -15 -15 -13 -97z"/>
<path d="M2720 1199 c0 -76 3 -100 13 -97 6 3 13 19 15 36 3 29 7 32 35 32 48
0 77 24 77 65 0 44 -29 65 -92 65 l-48 0 0 -101z m109 57 c21 -25 -4 -56 -43
-56 -30 0 -34 4 -38 30 -3 17 -2 32 0 35 11 11 70 4 81 -9z"/>
<path d="M2930 1206 c0 -56 4 -97 11 -101 15 -10 19 -3 22 36 2 28 6 34 26 34
18 0 29 -10 44 -37 10 -21 25 -38 33 -38 19 0 18 7 -7 46 l-20 33 20 20 c26
26 27 55 1 81 -15 15 -33 20 -75 20 l-55 0 0 -94z m117 44 c5 -26 -13 -41 -48
-43 -32 -2 -34 0 -37 31 l-3 33 43 -3 c28 -2 44 -8 45 -18z"/>
<path d="M3187 1289 c-21 -12 -47 -61 -47 -88 0 -81 104 -131 165 -78 48 42
49 112 1 160 -19 19 -90 23 -119 6z m106 -37 c22 -19 22 -79 0 -104 -18 -21
-70 -24 -94 -5 -9 7 -20 27 -24 45 -16 73 59 114 118 64z"/>
<path d="M3420 1210 c0 -49 -1 -93 -2 -97 -2 -5 20 -9 49 -11 45 -3 56 1 85
27 28 25 33 36 33 76 0 66 -34 95 -111 95 l-54 0 0 -90z m125 37 c36 -51 2
-117 -60 -117 -34 0 -35 1 -36 43 -1 23 -3 53 -4 67 -4 35 -2 36 44 32 28 -3
46 -11 56 -25z"/>
<path d="M3660 1230 c0 -38 5 -80 12 -94 20 -46 112 -44 137 3 6 11 11 51 11
90 0 56 -3 71 -15 71 -12 0 -15 -15 -15 -73 0 -78 -9 -97 -46 -97 -50 0 -54 7
-54 91 0 64 -3 79 -15 79 -12 0 -15 -14 -15 -70z"/>
<path d="M3919 1271 c-81 -81 26 -221 119 -155 27 18 20 39 -8 24 -52 -28
-110 5 -110 63 0 17 4 38 9 45 12 20 63 30 94 19 35 -12 49 0 23 19 -35 25
-94 18 -127 -15z"/>
<path d="M4120 1291 c0 -5 12 -11 28 -13 27 -3 27 -3 30 -90 2 -68 6 -88 17
-88 11 0 15 20 17 88 3 85 4 87 27 87 14 0 26 6 29 13 3 9 -17 12 -72 12 -42
0 -76 -4 -76 -9z"/>
<path d="M1523 933 c-3 -10 -19 -51 -35 -92 -19 -49 -26 -77 -19 -84 7 -7 14
-1 22 16 11 24 18 27 61 27 34 0 48 -4 48 -14 0 -17 28 -41 37 -32 4 3 -3 30
-16 59 -12 28 -29 71 -38 95 -16 45 -48 58 -60 25z m46 -64 c16 -46 14 -49
-19 -49 -33 0 -37 11 -20 54 13 35 26 33 39 -5z"/>
<path d="M1702 855 c3 -107 20 -128 28 -35 3 33 9 60 13 61 4 0 28 -27 53 -61
63 -87 74 -82 74 35 0 76 -3 95 -15 95 -11 0 -15 -16 -17 -67 l-3 -68 -50 68
c-29 39 -57 67 -68 67 -16 0 -17 -9 -15 -95z"/>
<path d="M1950 857 c0 -108 0 -108 79 -96 83 12 119 95 68 155 -20 23 -34 28
-85 32 l-62 4 0 -95z m114 52 c41 -32 33 -100 -14 -119 -29 -12 -77 -10 -72 3
1 4 2 36 2 72 0 65 0 65 29 65 15 0 40 -9 55 -21z"/>
<path d="M2296 934 c-19 -19 -21 -58 -3 -72 6 -5 27 -13 45 -17 73 -15 56 -73
-19 -61 -52 8 -50 -15 4 -28 51 -13 89 13 85 56 -3 31 -8 36 -63 60 -19 8 -30
21 -30 33 0 17 6 20 43 18 42 -2 56 9 26 21 -29 11 -72 6 -88 -10z"/>
<path d="M2480 855 l0 -95 40 -2 c22 -1 50 -2 62 -2 12 -1 23 5 26 12 2 8 -11
12 -47 12 -50 0 -51 1 -51 30 0 29 2 30 46 30 32 0 44 4 41 13 -2 7 -21 12
-43 12 -37 0 -39 2 -42 33 l-3 32 50 0 c28 0 51 5 51 10 0 6 -28 10 -65 10
l-65 0 0 -95z"/>
<path d="M2680 850 c0 -80 3 -100 14 -100 10 0 16 13 18 38 2 29 8 38 25 40
16 2 26 -5 37 -26 16 -32 44 -58 52 -49 3 3 -2 20 -11 38 -16 30 -16 34 0 61
34 58 -3 98 -90 98 l-45 0 0 -100z m104 67 c25 -18 17 -50 -15 -61 -41 -14
-59 -2 -59 39 0 32 3 35 28 35 16 0 36 -6 46 -13z"/>
<path d="M2880 942 c0 -11 70 -176 78 -184 13 -14 28 7 57 82 35 89 40 113 23
108 -7 -3 -23 -31 -36 -64 -13 -32 -27 -63 -31 -67 -5 -5 -21 24 -37 62 -16
39 -35 71 -41 71 -7 0 -13 -4 -13 -8z"/>
<path d="M3122 855 c4 -127 22 -129 26 -2 2 83 0 97 -13 97 -13 0 -15 -14 -13
-95z"/>
<path d="M3253 932 c-60 -46 -43 -144 30 -171 34 -13 42 -12 74 3 45 21 32 42
-14 24 -60 -23 -111 25 -94 89 11 41 51 61 92 46 37 -14 47 -10 29 12 -17 21
-89 19 -117 -3z"/>
<path d="M3467 943 c-4 -3 -7 -46 -7 -94 l0 -87 55 -7 c54 -6 75 -2 75 16 0 5
-22 9 -50 9 -49 0 -50 1 -50 29 0 28 3 30 43 33 23 2 42 8 42 13 0 6 -19 11
-42 13 -40 3 -43 5 -43 33 0 28 1 29 50 29 28 0 50 5 50 10 0 11 -113 14 -123
3z"/>
<path d="M3664 925 c-15 -22 -15 -27 -1 -48 8 -13 34 -29 57 -36 34 -10 41
-16 38 -34 -2 -18 -9 -22 -38 -21 -19 0 -41 2 -49 5 -7 2 -15 -1 -18 -8 -7
-20 64 -37 97 -23 59 24 51 80 -15 106 -32 12 -45 22 -45 36 0 24 25 33 55 20
17 -8 26 -8 31 -1 10 16 -16 29 -58 29 -29 0 -41 -6 -54 -25z"/>
<path d="M0 40 l0 -40 2700 0 2700 0 0 40 0 40 -2700 0 -2700 0 0 -40z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
